import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {MatCardModule} from "@angular/material/card";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {LicenseModel} from "../../domain/models/license.model";
import {FormValidationUtil} from "../../utils/form-validation.util";

@Component({
  selector: 'app-licenses',
  standalone: true,
  imports: [ReactiveFormsModule, MatFormField, MatInput, MatLabel, MatCardModule, MatCheckboxModule, ReactiveFormsModule, MatButton, MatIcon],
  templateUrl: './licenses.component.html',
  styleUrl: './licenses.component.css'
})
export class LicensesComponent implements AfterViewInit, OnInit {
  @Input() license: LicenseModel | undefined = {};
  licenseForm!: FormGroup;

  constructor(private fb: FormBuilder) {
  }

  getUpdatedLicense(): LicenseModel {
    const formValues = this.licenseForm.value;
    return {
      regulationLicenseNumber: formValues.licenseNumber,
      taxCertificateNumber: formValues.taxNumber,
      stateCertificateHasBeenApplied: formValues.appliedFor,
      reasonWhy: formValues.notRegisteredReason
    }
  }

  isFormValid(): boolean {
    return this.licenseForm.valid;
  }

  ngAfterViewInit(): void {
    this.buildForm(this.license);
  }

  ngOnInit(): void {
    this.buildForm(this.license);
  }

  raiseFormValidations(): void {
    this.licenseForm.markAllAsTouched();
  }

  onTaxNumberBlur(): void {
    const control = this.licenseForm.get('taxNumber');
    control?.setValue(FormValidationUtil.formatTaxCertificateNumber(control.value ?? ''));
  }

  private buildForm(info: LicenseModel | undefined): void {
    this.licenseForm = this.fb.group({
      licenseNumber: [info?.regulationLicenseNumber ?? ''],
      taxNumber: [FormValidationUtil.formatTaxCertificateNumber(info?.taxCertificateNumber ?? ''), Validators.required],
      appliedFor: [info?.stateCertificateHasBeenApplied ?? '', Validators.required],
      notRegisteredReason: [info?.reasonWhy ?? '', [Validators.required]],
    });
  }
}
